<template>
    <div id="site-footer" v-observe-visibility="{callback: (isVisible) => visible = isVisible, once: true, throttle: 800}"
         :class="visible ? 'show' : ''">
        <b-container>
            <b-row>
                <b-col cols="12" sm="6" lg="3">
                    <div class="footerinfo-element">
                        <p class="footerinfo-element__heading">
                            Contact Us
                        </p>
                        <ul class="desktop-contact">
                            <li><a :href="'tel:' + getSettings.ContactPhone">{{ getSettings.ContactPhone }}</a></li>
                            <li><a :href="'mailTo:' + getSettings.ContactEmail">{{ getSettings.ContactEmail }}</a></li>
                            <li><a v-if="getSettings.ContactPage" :href="getSettings.ContactPage.Link">Contact Us</a></li>
                            <li><a href="/our-story/news">News</a></li>
                        </ul>
                        <ul class="mobile-contact">
                            <li><a :href="'tel:' + getSettings.ContactPhone"><span><i class="fal fa-phone"></i></span></a></li>
                            <li><a :href="'mailTo:' + getSettings.ContactEmail"><span><i class="fal fa-envelope"></i></span></a></li>
                            <li><a v-if="getSettings.ContactPage" :href="getSettings.ContactPage.Link"><span><i
                                class="fal fa-map-marker-alt"></i></span></a></li>
                            <li><a href="/our-story/news">News</a></li>
                        </ul>
                    </div>
                </b-col>
                <b-col cols="12" sm="6" lg="4">
                    <div class="footerinfo-element">
                        <p class="footerinfo-element__heading">
                            Visit the winery
                        </p>
                        <ul class="opening-times">
                            <li>
                                <span class="opening-times__label">Cellar Door</span>
                                <span class="opening-times__time">{{ getSettings.CellarOpeningHours }}</span>
                            </li>
                            <li>
                                <span class="opening-times__label">Cheesery & Deli</span>
                                <span class="opening-times__time">{{ getSettings.DeliOpeningHours }}</span>
                            </li>
                            <li>
                                <span class="opening-times__label">Restaurant</span>
                                <span class="opening-times__time">{{ getSettings.RestaurantOpeningHours }}</span>
                            </li>
                            <li>
                                <span class="opening-times__label">Cave & Winery Tours</span>
                                <span class="opening-times__time">{{ getSettings.WineryOpeningHours }}</span>
                            </li>
                        </ul>
                    </div>
                </b-col>
                <b-col cols="12" lg="4">
                    <div class="footerinfo-element">
                        <p class="footerinfo-element__heading">
                            Stay in touch
                        </p>
                        <p v-if="getFooterSubscribeMessage">{{ getFooterSubscribeMessage }}</p>

                        <div class="c7-subscribe" data-has-name-fields="true"></div>


                        <!--<form class="footer-subscribe" @submit.prevent="subscribe" v-else>
                            <b-input-group>
                                <b-form-input type="text" autocomplete="off" v-model="subscriberFirstname" required placeholder="First Name"></b-form-input>
                                <b-form-input type="text" autocomplete="off" v-model="subscriberSurname" required placeholder="Last Name"></b-form-input>
                                <b-form-input type="email" autocomplete="off" v-model="subscriberEmail" required placeholder="Email"></b-form-input>
                                <b-input-group-append>
                                    <b-button type="submit" size="sm" text="Button"><i class="fal fa-arrow-right"></i></b-button>
                                </b-input-group-append>
                            </b-input-group>
                        </form>-->
                        <ul class="footer-socials">
                            <li>
                                <a v-if="getSettings.FacebookLink" target="_blank" :href="getSettings.FacebookLink">
                                    <span>
                                        <i class="fab fa-facebook-f"></i>
                                    </span>
                                </a>
                                <a v-if="getSettings.InstagramLink" target="_blank" :href="getSettings.InstagramLink">
                                    <span>
                                        <i class="fab fa-instagram"></i>
                                    </span>
                                </a>
                                <a v-if="getSettings.TwitterLink" target="_blank" :href="getSettings.TwitterLink">
                                    <span>
                                        <i class="fab fa-twitter"></i>
                                    </span>
                                </a>
                                <a v-if="getSettings.PinterestLink" target="_blank" :href="getSettings.PinterestLink">
                                    <span>
                                        <i class="fab fa-pinterest-p"></i>
                                    </span>
                                </a>
                                <a v-if="getSettings.YoutubeLink" target="_blank" :href="getSettings.YoutubeLink">
                                    <span>
                                        <i class="fab fa-youtube"></i>
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </div>
                </b-col>
            </b-row>

            <b-row>
                <b-col col>
                    <div class="footer-logos">
                        <div class="left-col">
                            <div class="logoimage-wrapper">
                                <img v-if="getSettings.OtherLogoOne" :src="getSettings.OtherLogoOne.URL" alt=""
                                     :title="getSettings.OtherLogoOne.Title">
                            </div>
                            <div class="logoimage-wrapper">
                                <img v-if="getSettings.OtherLogoTwo" :src="getSettings.OtherLogoTwo.URL" alt=""
                                     :title="getSettings.OtherLogoTwo.Title">
                            </div>
                            <div class="logoimage-wrapper">
                                <img v-if="getSettings.OtherLogoThree" :src="getSettings.OtherLogoThree.URL" alt=""
                                     :title="getSettings.OtherLogoThree.Title">
                            </div>
                            <span class="script-text">Good wine, good food, good living</span>
                        </div>
                        <div class="right-col">
                            <img v-if="getSettings.LogoContrast" :src="getSettings.LogoContrast.URL" alt="" :alt="getSettings.LogoContrast.Title">
                        </div>
                    </div>

                </b-col>
            </b-row>

            <b-row>
                <b-col>
                    <ul class="footer-navigation">
                        <li><a v-if="getSettings.ShippingReturns" :href="getSettings.ShippingReturns.Link">Shipping & Returns</a></li>
                        <li><a v-if="getSettings.TermsConditions" :href="getSettings.TermsConditions.Link">Terms & Conditions</a></li>
                        <li><a v-if="getSettings.HeathSafety" :href="getSettings.HeathSafety.Link">Health & Safety</a></li>
                        <li><a v-if="getSettings.Jobs" :href="getSettings.Jobs.Link">Job Vacancies</a></li>
                        <li><a v-if="getSettings.LicenceInformation" :href="getSettings.LicenceInformation.Link">Licence Information</a></li>
                        <li><p style="color:rgba(255, 255, 255, 0.5)">{{ getSettings.LicenceCode }}</p></li>
                    </ul>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
    name: "SiteFooter",
    data() {
        return {
            visible: false,
            subscriberEmail: '',
            subscriberFirstname: '',
            subscriberSurname: ''
        }
    },
    computed: {
        ...mapGetters(['getSettings', 'getFooterSubscribeMessage'])
    },
    methods: {
        ...mapActions(['createSubscriber']),
        subscribe() {
            if (this.subscriberEmail !== '' && this.subscriberFirstname !== '' && this.subscriberSurname !== '') {
                let data = new FormData();
                data.append('Email', this.subscriberEmail);
                data.append('FirstName', this.subscriberFirstname);
                data.append('LastName', this.subscriberSurname);
                this.createSubscriber(data);
            }
        }
    }
}
</script>
